/* ==========================================================
   COLHIDA — Página de produto
   Troca de variante, quantidade, galeria e barra fixa.
   Sem dependências. Escopo por seção.
   ========================================================== */
(function () {
  "use strict";

  var raizRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";

  /* ---------- abre a gaveta lateral ----------
     Usa a API oficial Shopify.actions.openCart() do tema (definida em
     standard-actions-override.js). Fallbacks só por segurança. */
  function abrirGavetaComEstado(parsedState) {
    // 1) caminho oficial do tema
    try {
      if (window.Shopify && window.Shopify.actions && typeof window.Shopify.actions.openCart === "function") {
        window.Shopify.actions.openCart();
        return true;
      }
    } catch (e) {}

    // 2) método open() do elemento <cart-drawer>
    var drawer = document.querySelector("cart-drawer");
    if (drawer) {
      try {
        if (parsedState && parsedState.sections && parsedState.sections["cart-drawer"] && typeof drawer.renderContents === "function") {
          drawer.renderContents(parsedState);
          return true;
        }
        if (typeof drawer.open === "function") { drawer.open(); return true; }
      } catch (e) {}
      // 3) força pelas classes
      try {
        drawer.classList.remove("is-empty");
        drawer.classList.add("animate", "active");
        document.body.classList.add("overflow-hidden");
        return true;
      } catch (e2) {}
    }
    return false;
  }

  // ids das seções que a gaveta do Origin precisa pra se atualizar
  function idsDasSecoes() {
    var ids = [];
    var drawer = document.querySelector("cart-drawer");
    if (drawer && typeof drawer.getSectionsToRender === "function") {
      try {
        drawer.getSectionsToRender().forEach(function (s) { if (s && s.id) ids.push(s.id); });
      } catch (e) {}
    }
    var itens = document.querySelector("cart-drawer-items");
    if (itens && typeof itens.getSectionsToRender === "function") {
      try {
        itens.getSectionsToRender().forEach(function (s) { if (s && s.section && ids.indexOf(s.section) === -1) ids.push(s.section); });
      } catch (e) {}
    }
    if (!ids.length) ids = ["cart-drawer", "cart-icon-bubble"];
    return ids;
  }

  function iniciar(raiz) {
    if (!raiz || raiz.dataset.clhIniciado === "1") return;
    raiz.dataset.clhIniciado = "1";

    var dados = raiz.querySelector("[data-clh-variantes]");
    var variantes = [];
    if (dados) {
      try { variantes = JSON.parse(dados.textContent); } catch (e) { variantes = []; }
    }

    var campoId   = raiz.querySelector("[data-clh-id]");
    var elPreco   = raiz.querySelector("[data-clh-preco]");
    var elAntes   = raiz.querySelector("[data-clh-antes]");
    var elUnit    = raiz.querySelector("[data-clh-unit]");
    var cta       = raiz.querySelector("[data-clh-cta]");
    var barra     = raiz.querySelector("[data-clh-barra]");
    var barraPreco= raiz.querySelector("[data-clh-barra-preco]");
    var ctaBarra  = raiz.querySelector("[data-clh-cta-barra]");
    var opcoes    = raiz.querySelectorAll("[data-clh-opt]");

    /* ---------- variantes ---------- */

    function selecionadas() {
      var vals = [];
      opcoes.forEach(function (inp) {
        if (inp.checked) vals[parseInt(inp.dataset.clhOpt, 10)] = inp.value;
      });
      return vals;
    }

    function achar() {
      var alvo = selecionadas();
      if (!alvo.length) return variantes[0];
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i], bate = true;
        for (var k = 0; k < alvo.length; k++) {
          if (alvo[k] !== undefined && v.options[k] !== alvo[k]) { bate = false; break; }
        }
        if (bate) return v;
      }
      return null;
    }

    function render() {
      var v = achar();

      if (!v) {
        if (cta) { cta.disabled = true; cta.textContent = "Combinação indisponível"; }
        return;
      }

      if (campoId) campoId.value = v.id;
      if (elPreco) elPreco.textContent = v.preco;

      if (elAntes) {
        if (v.antes) { elAntes.textContent = v.antes; elAntes.hidden = false; }
        else { elAntes.hidden = true; }
      }

      if (elUnit) {
        if (v.unit) { elUnit.textContent = v.unit; elUnit.hidden = false; }
        else { elUnit.hidden = true; }
      }

      if (cta) {
        cta.disabled = !v.disponivel;
        cta.textContent = v.disponivel ? cta.dataset.clhLabel : "Esgotado";
      }
      if (ctaBarra) {
        ctaBarra.disabled = !v.disponivel;
        ctaBarra.textContent = v.disponivel ? "Adicionar" : "Esgotado";
      }
      if (barraPreco) {
        barraPreco.textContent = v.preco + (v.titulo && v.titulo !== "Default Title" ? " · " + v.titulo : "");
      }

      // marca opções sem estoque
      opcoes.forEach(function (inp) {
        var lab = raiz.querySelector('label[for="' + inp.id + '"]');
        if (!lab) return;
        var idx = parseInt(inp.dataset.clhOpt, 10);
        var existe = variantes.some(function (x) {
          return x.options[idx] === inp.value && x.disponivel;
        });
        lab.classList.toggle("is-esgotado", !existe);
      });

      // atualiza a URL sem recarregar
      if (window.history && window.history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", u.toString());
      }
    }

    opcoes.forEach(function (inp) { inp.addEventListener("change", render); });
    render();

    /* ---------- quantidade ---------- */

    var campoQtd = raiz.querySelector("[data-clh-qtd]");
    raiz.querySelectorAll("[data-clh-passo]").forEach(function (b) {
      b.addEventListener("click", function () {
        var n = parseInt(campoQtd.value, 10) + parseInt(b.dataset.clhPasso, 10);
        campoQtd.value = Math.min(99, Math.max(1, isNaN(n) ? 1 : n));
      });
    });

    /* ---------- adicionar à sacola (AJAX) ---------- */

    var form = raiz.querySelector("[data-clh-form]");

    function feedback(btn, txt) {
      if (!btn) return;
      var orig = btn.dataset.clhLabel || btn.textContent;
      btn.textContent = txt;
      btn.classList.add("is-ok");
      setTimeout(function () {
        btn.textContent = orig;
        btn.classList.remove("is-ok");
      }, 1800);
    }

    function enviar(btn) {
      if (!form) return;
      var v = achar();
      if (!v || !v.disponivel) return;

      // ID da variante: prioriza o campo escondido preenchido pelo Liquid
      // (à prova de erro para produtos sem variantes, como a Caixa).
      var idVariante = (campoId && campoId.value) ? campoId.value : v.id;

      btn.disabled = true;

      var corpo = {
        items: [{ id: idVariante, quantity: parseInt(campoQtd ? campoQtd.value : 1, 10) || 1 }],
        sections: idsDasSecoes().join(","),
        sections_url: window.location.pathname
      };

      fetch(raizRoot + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(corpo)
      })
        .then(function (r) { return r.json(); })
        .then(function (estado) {
          feedback(btn, "Adicionado");
          document.dispatchEvent(new CustomEvent("clh:sacola-atualizada"));
          atualizarContador();
          // abre a gaveta lateral nativa, já com o item novo
          var abriu = abrirGavetaComEstado(estado);
          if (!abriu) {
            // sem gaveta na página: leva pra sacola
            window.location.href = raizRoot + "cart";
          }
        })
        .catch(function () {
          form.submit(); // se o AJAX falhar, envia o formulário normalmente
        })
        .finally(function () { btn.disabled = false; });
    }

    if (cta) cta.addEventListener("click", function (e) { e.preventDefault(); enviar(cta); });
    if (ctaBarra) ctaBarra.addEventListener("click", function (e) { e.preventDefault(); enviar(ctaBarra); });

    function atualizarContador() {
      fetch("/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll("[data-clh-sacola-contador]").forEach(function (el) {
            el.textContent = c.item_count;
          });
        })
        .catch(function () {});
    }

    /* ---------- galeria ---------- */

    var trilho = raiz.querySelector("[data-clh-trilho]");
    var conta  = raiz.querySelector("[data-clh-conta]");
    if (trilho && conta) {
      trilho.addEventListener("scroll", function () {
        var figs = trilho.children;
        var meio = trilho.scrollLeft + trilho.clientWidth / 2;
        var i = 0;
        for (var k = 0; k < figs.length; k++) {
          if (figs[k].offsetLeft <= meio && figs[k].offsetLeft + figs[k].offsetWidth > meio) { i = k; break; }
        }
        conta.textContent = ("0" + (i + 1)).slice(-2);
      }, { passive: true });
    }

    /* ---------- barra fixa ---------- */

    if (barra && cta && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entradas) {
        barra.classList.toggle("is-show", !entradas[0].isIntersecting);
      }, { rootMargin: "0px 0px -40px 0px" }).observe(cta);
    }
  }

  function varrer() {
    document.querySelectorAll("[data-clh-produto]").forEach(iniciar);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", varrer);
  } else {
    varrer();
  }

  // reinicializa quando o editor de temas recarrega a seção
  document.addEventListener("shopify:section:load", function (e) {
    var alvo = e.target.querySelector("[data-clh-produto]");
    if (alvo) iniciar(alvo);
  });
})();